/* eslint-env browser */
module.exports = typeof self == 'object' ? self.FormData : window.FormData;



//////////////////
// WEBPACK FOOTER
// ./~/form-data/lib/browser.js
// module id = 640
// module chunks = 0